export default __webpack_public_path__ + "static/media/story_img_case1.5e90c5f7.jpg";